import {
  Github, Cloud, Mail, Database, Globe, Shield, Terminal, Code, Cpu, Server,
  Lock, Link, LayoutDashboard, CreditCard, BarChart3, Figma, Slack, Cog,
} from "lucide-react";

export const ICONS = {
  github: Github,
  cloud: Cloud,
  mail: Mail,
  database: Database,
  globe: Globe,
  shield: Shield,
  terminal: Terminal,
  code: Code,
  cpu: Cpu,
  server: Server,
  lock: Lock,
  link: Link,
  dashboard: LayoutDashboard,
  payment: CreditCard,
  analytics: BarChart3,
  design: Figma,
  slack: Slack,
  settings: Cog,
};

export const ICON_OPTIONS = [
  { value: "github", label: "GitHub" },
  { value: "cloud", label: "Cloud / Cloudflare" },
  { value: "mail", label: "Email / Zoho" },
  { value: "database", label: "Database / Supabase" },
  { value: "globe", label: "Sito Web" },
  { value: "shield", label: "Admin / Sicurezza" },
  { value: "terminal", label: "Terminale" },
  { value: "code", label: "Codice" },
  { value: "server", label: "Server" },
  { value: "cpu", label: "Sistema" },
  { value: "lock", label: "Lucchetto" },
  { value: "dashboard", label: "Dashboard" },
  { value: "payment", label: "Pagamenti" },
  { value: "analytics", label: "Analytics" },
  { value: "design", label: "Design / Figma" },
  { value: "slack", label: "Slack" },
  { value: "settings", label: "Impostazioni" },
  { value: "link", label: "Generico" },
];

export const CATEGORIES = [
  "Codice & Deploy",
  "Infrastruttura & DNS",
  "Database & Backend",
  "Comunicazione",
  "Frontend & Landing",
  "Amministrazione",
  "Design & Utilities",
  "Altro",
];

export const BADGE_COLORS = {
  slate: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  amber: "bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-400",
  purple: "bg-purple-100 text-purple-700 dark:bg-purple-950 dark:text-purple-400",
  emerald: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-400",
  sky: "bg-sky-100 text-sky-700 dark:bg-sky-950 dark:text-sky-400",
  rose: "bg-rose-100 text-rose-700 dark:bg-rose-950 dark:text-rose-400",
};

export const ICON_TINT = {
  slate: "text-slate-600 bg-slate-100 dark:text-slate-300 dark:bg-slate-800",
  amber: "text-amber-600 bg-amber-100 dark:text-amber-400 dark:bg-amber-950",
  purple: "text-purple-600 bg-purple-100 dark:text-purple-400 dark:bg-purple-950",
  emerald: "text-emerald-600 bg-emerald-100 dark:text-emerald-400 dark:bg-emerald-950",
  sky: "text-sky-600 bg-sky-100 dark:text-sky-400 dark:bg-sky-950",
  rose: "text-rose-600 bg-rose-100 dark:text-rose-400 dark:bg-rose-950",
};

export const BADGE_COLOR_OPTIONS = [
  { value: "slate", label: "Grigio" },
  { value: "sky", label: "Azzurro" },
  { value: "emerald", label: "Verde" },
  { value: "amber", label: "Ambra" },
  { value: "purple", label: "Viola" },
  { value: "rose", label: "Rosa" },
];

export const STATUS_META = {
  online: { label: "Online", dot: "bg-emerald-500" },
  warning: { label: "Manutenzione", dot: "bg-amber-500" },
  offline: { label: "In Sviluppo", dot: "bg-slate-400" },
};
